import React from "react";
import styled, { css } from "styled-components";
import { useHistory } from "react-router-dom";

import { Text } from "src/library/components/Text";
import { ActionButton } from "src/library/components/Button";

import PromotionalTagColorLabel from "./PromotionalTagColorLabel";

export interface PromotionTagUneditableCardProps {
  id: number;
  label: string;
  color: string;
}

/**
 * uneditable promotial tag card if user does not have sufficient permissions
 *
 * @returns a promotion tag row element
 */
export const PromotionTagUneditableCard: React.ReactFCWithChildren<PromotionTagUneditableCardProps> = ({
  id, label, color
}) => {
  const history = useHistory();

  return (
    <>
      <RowWrapper>
        <div className="info">
          <Text>
            {label}
          </Text>

          <PromotionalTagColorLabel color={color} />
        </div>

        <ActionButton
          title="Actions"
          items={[
            {
              title: "View Promotional Tag",
              action: () => history.push(`/admin/promotions/promotional-tags/${id}`)
            }
          ]}
        />
      </RowWrapper>
    </>
  );
};

const RowWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    align-items: center;
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.sm} ${theme.spacing.padding.md}; 
    border-bottom: ${theme.colors.lightGrey} 1px solid;
    height: 45px;
    justify-content: space-between;
    padding: ${theme.spacing.padding.lg};

    .info {
      display: flex;
      align-items: center;
    }

    .icon-wrapper {
      width: 30px;

      svg:hover {
        cursor: pointer;
      }
    }
  `}
`;
